import {ControlValueAccessor} from '@angular/forms';

export class CVA implements ControlValueAccessor {
	public cva = {
		value: null,
		onChangeFunction: (val) => {
		},
		onTouchedFunction: (val) => {
		}
	};

	writeValueFromInput(obj) {
		console.log('writeValueFromInput', obj);
		this.cva.value = obj;
		this.cva.onChangeFunction(obj);
		this.cva.onTouchedFunction(obj);
	}

	writeValue(obj: any) {
		// if (obj) {
			this.cva.value = obj;
			this.cva.onChangeFunction(obj);
			this.cva.onTouchedFunction(obj);
		// }
	}

	registerOnChange(fn: any) {
		this.cva.onChangeFunction = fn;
	}

	registerOnTouched(fn: any) {
		this.cva.onTouchedFunction = fn;
	}
}
